import React from "react";
import "./AboutUs.css";

const sections = [
  {
    icon: <i className="fa-solid fa-bullseye" />,
    title: "Our Mission",
    body: "To simplify logistics by connecting businesses with reliable transporters through a fast, transparent, and efficient digital platform — making moving goods easier and more dependable across Africa."
  },
  {
    icon: <i className="fa-solid fa-globe" />,
    title: "Our Vision",
    body: "To become Africa's most trusted logistics platform, empowering businesses to move goods effortlessly while enabling transporters to maximize their earnings through smarter technology."
  },
  {
    icon: <i className="fa-solid fa-lightbulb" />,
    title: "Why We Started",
    body: "Many businesses struggle to find reliable transport, while truck owners often return empty after deliveries. We built Mr Truck to bridge this gap — connecting demand with available capacity through a simple digital platform."
  },
  {
    icon: <i className="fa-solid fa-users" />,
    title: "Leadership",
    body: "Our leadership brings together expertise in logistics, technology, and business operations. We are committed to building a platform that supports both businesses and transporters at the highest standards of reliability."
  },
  {
    icon: <i className="fa-solid fa-shield-halved" />,
    title: "Safety Standards",
    body: "Safety is central to everything we do. We work with verified drivers, maintain strict operational standards, and continuously monitor deliveries to ensure goods move securely from pickup to destination."
  },
  {
    icon: <i className="fa-solid fa-bolt" />,
    title: "Technology & Security",
    body: "Through real-time tracking, smart matching algorithms, and secure digital systems — including escrow-protected payments — we provide full transparency and reliability for businesses and transporters alike."
  }
];

const stats = [
  { number: "6+", label: "Truck Categories" },
  { number: "Africa", label: "Pan-African Coverage" },
  { number: "eTIMS", label: "Receipts Issued" },
  { number: "Escrow", label: "Secured Payments" },
];

export default function AboutUs() {
  return (
    <div>
      {/* PAGE HERO */}
      <div className="page-hero">
        <span className="page-hero-label">Our Story</span>
        <h1>Built to Move Africa Forward</h1>
        <p>
          Mr Truck is a modern logistics platform operated by Bridgeway Supply Chain Limited,
          connecting businesses and individuals with verified trucks across Africa.
        </p>
      </div>

      {/* STAT STRIP */}
      <div className="stat-strip">
        <div className="stat-strip-inner">
          {stats.map((s, i) => (
            <div className="stat-item" key={i}>
              <span className="stat-number">{s.number}</span>
              <span className="stat-label">{s.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* ABOUT SECTIONS */}
      <div className="page-section">
        <span className="section-label">Who We Are</span>
        <h2>The Team &amp; Values Behind Mr Truck</h2>
        <p className="page-section-subtitle">
          We are a fast-growing logistics startup on a mission to make transport simple, transparent, and reliable for businesses across Africa.
        </p>

        <div className="about-grid">
          {sections.map((s, i) => (
            <div className="about-card" key={i}>
              <span className="about-card-icon">{s.icon}</span>
              <h3>{s.title}</h3>
              <p>{s.body}</p>
            </div>
          ))}
        </div>
      </div>

      {/* CTA */}
      <div className="page-cta bg-brand">
        <h2>Ready to experience the difference?</h2>
        <p>Join thousands of businesses that trust Mr Truck for their logistics needs.</p>
        <a
          href="https://play.google.com/store/apps/details?id=com.MrTruck"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="btn-white">Book a Truck ↗</button>
        </a>
      </div>
    </div>
  );
}
